import { Injectable } from '@angular/core';
import {Session} from '../../shared/domain/session';
import {Response} from '../../shared/domain/Response';
import {Observable} from 'rxjs/Observable';
import {HttpClient} from '@angular/common/http';
import {UserDB} from '../../shared/domain/userDB';
import {Router} from '@angular/router';
import {AuthenticationService} from "./authentication.service";

@Injectable()
export class SessionService {
    public session: Session;
    private urlWhiteList = '/api/whiteList/';

    constructor(private http: HttpClient,
                private router: Router,
                private authentication: AuthenticationService) {
    }

    setSession(data: any) {
        this.session = new Session(
            data.idGoogle,
            data.name,
            data.imgUrl,
            data.email,
            data.id,
            data.type
        );
    }

    getSession() {
        if (this.session != undefined) {
            return this.session;
        }
        else {
            const data = this.authentication.getAllCookies();
            this.setSession(data);
            return this.session;
        }
    }

    initSession(data) {
        this.setSession(data);
        this.startSession();
    }

    getLoggedState() {
        return this.authentication.isAuthenticated();
    }

    checkSessionState(type: string) {
        this.authentication.validateType(type);
    }

    startSession() {
        if (this.getLoggedState())
            this.authentication.login(this.session);
    }

    endSession() {
        this.authentication.logout();
    }

    checkToWhiteList(email): Observable<Response> {
        return this.http.get<Response>(this.urlWhiteList + email);
    }
}


// WEBPACK FOOTER //
// ./src/app/core/services/sessionService.ts